import React from 'react'
import CartProductsList from './CartProductsList'
import { IoAirplane, IoBoat } from 'react-icons/io5'
import '../css/resume.css'
import { FaTruck } from 'react-icons/fa'

const OrderResume = ({ cart, transport, box }) => {

  const numberOfBoxes = () => {
    let diviser = 0;
    let totalWeight = 0;
    cart.map(item => totalWeight += parseInt(item.quantity));

    transport == "avion" ? diviser = 4 : diviser = 6;
    const nbr = totalWeight / diviser;
    return Math.round(nbr);
  }

  return (
    <div className="resume container__resume">
        {/* <h2>Résumé de votre commande</h2> */}
        <h2>Résumé des commande</h2>
        <CartProductsList cart={cart} page="checkout" />

        {/* <h3>Vos préférences</h3> */}
        <h3>Préférences</h3>

        <div className="preference__box">
          <div className="preference__box__img">
            <img src={box.img} alt="" />
          </div>
          <div className="preference__box__text">
            Type de carton : {box.nom}<br/>
            <span>{numberOfBoxes()} cartons</span>
          </div>
        </div>

        <div className="preference__box">
          <div className="preference__box__img">
            <div className="icon">
              {transport == "avion" ? <IoAirplane /> : transport == "bateau" ? <IoBoat /> : <FaTruck />}
            </div>
          </div>
          <div className="preference__box__text">
            Transportés par {transport}
          </div>
        </div>
    </div>
  )
}

export default OrderResume